import { atom, useRecoilValue, useRecoilTransaction_UNSTABLE } from "recoil";

import activities from "../../../redux/activities";
import { QueryStatus } from "../../../services";
import { SimpleSetValue } from "../../../types";

/////////
// START: Block to be removed once deprecated user hook is removed.
/////////

// Do NOT export atoms.
// This allows us to limit usage of these to only the hooks we export below.

const userGlobalActivityAtom = atom<activities>({
  key: "[@fabric/core] userGlobalActivityAtom",
  default: activities.idling,
});

const userGlobalStatusAtom = atom<QueryStatus>({
  key: "[@fabric/core] userGlobalStatusAtom",
  default: "idle",
});

// ###########################
// ## useUserGlobalActivity ##
// ###########################

export type ResultOfUseUserGlobalActivity = activities;
export type UseUserGlobalActivity = () => ResultOfUseUserGlobalActivity;

/**
 * @returns The last user activity, whether from `useUser` or `useUpdateUser`
 *
 * @deprecated Use `useUser` or `useUpdateUser` instead. This is only necessary to support deprecated hooks.
 */
export const useUserGlobalActivity: UseUserGlobalActivity = () => {
  return useRecoilValue(userGlobalActivityAtom);
};

// #########################
// ## useUserGlobalStatus ##
// #########################

export type ResultOfUseUserGlobalStatus = QueryStatus;
export type UseUserGlobalStatus = () => ResultOfUseUserGlobalStatus;

/**
 * @returns the last status of the last user activity, whether from `useUser` or `useUpdateUser`.
 *
 * @deprecated Use `useUser` or `useUpdateUser` instead. This is only necessary to support deprecated hooks.
 */
export const useUserGlobalStatus: UseUserGlobalStatus = () => {
  return useRecoilValue(userGlobalStatusAtom);
};

// #######################################
// ## useSetUserGlobalActivityAndStatus ##
// #######################################

export type ResultOfUseSetUserGlobalActivityAndStatus = SimpleSetValue<{
  activity: activities;
  status: QueryStatus;
}>;
export type UseSetUserGlobalActivityAndStatus =
  () => ResultOfUseSetUserGlobalActivityAndStatus;

/**
 * Allows setting the last user activity and
 * the status of that activity.
 *
 * @deprecated This is only necessary to support deprecated hooks.
 */
export const useSetUserGlobalActivityAndStatus: UseSetUserGlobalActivityAndStatus =
  () => {
    // Using useRecoilTransaction_UNSTABLE ensures that the atoms are updated atomically
    return useRecoilTransaction_UNSTABLE(
      ({ set }) =>
        (payload) => {
          set(userGlobalActivityAtom, payload.activity);
          set(userGlobalStatusAtom, payload.status);
        },
      [],
    );
  };

///////
// END: Block to be removed once deprecated user hook is removed.
///////
